import { render } from "htm/preact"
import { useRef, useState } from "preact/hooks"
import { del, get, patch, post } from "src/utils/http";
import CreateModal from "./CreateModal";
import Modal from "src/components/Modal";
import "./style.css"
import { FloatingButtons } from "src/components/FloatingButtons";
import Leaderboard from "src/components/Leaderboard";

const App = () => {
    const url = "https://leaderboardb.swoogo-retrofit.tkevents.io"

    const [achievements, setAchievements] = useState(null);
    const [events, setEvents] = useState(null)
    const [eventId, setEventId] = useState(null)
    const input = useRef(null)

    const paths = {
        GET_ALL_BY_EVENT: (eventId) => `/achievements/by-event/${eventId}`,
        GET_ALL_EVENTS: () => "/events/all",
        CREATE_ACHIEVEMENT: () => "/achievements/create",
        DELETE_ACHIEVEMENT: (id) => `/achievements/${id}`,
        UPDATE_ACHIEVEMENT: (id) => `/achievements/${id}`,
        FLUSH_POINTS: (eventId) => `/achievements/by-event/${eventId}`,
        GET_REPORT: () => `/report/${eventId}`
    }

    if (achievements == null && eventId) {
        get(`${url}${paths.GET_ALL_BY_EVENT(eventId)}`, {}, { headers: { authorization: "test" } }).then(setAchievements)
    }
    
    const getAllEvents = () => {
        get(`${url}${paths.GET_ALL_EVENTS()}`, {}, { headers: { authorization: "test" } }).then(setEvents)
    }

    if(events == null) getAllEvents()

    const addRuleRef = useRef(null)
    const updateRuleRef = useRef(null)
    const updateModal = useRef(null)

    const submit = () => {
        if (input.current == null) return;

        setAchievements(null)

        const { value } = input.current
        if (value.length > 0) setEventId(value)
    }

    const report = () => {
        if (!eventId) return;

        window.open(`${url}${paths.GET_REPORT()}`)
    }

    const formSubmit = (data) => {
        post(`${url}${paths.CREATE_ACHIEVEMENT()}`, data, { headers: { authorization: "test" } }).then(addRuleRef.current.hide)
        setAchievements(null)
    }

    const updateSubmit = (data, initial) => {
        patch(`${url}${paths.UPDATE_ACHIEVEMENT(initial.id)}`, data, { headers: { authorization: "test" } }).then(updateRuleRef.current.hide)
        setAchievements(null)
    }

    const deleteAch = (achievementId) => {
        del(`${url}${paths.DELETE_ACHIEVEMENT(achievementId)}`, {}, { headers: { authorization: "test" } }).then(submit)
    }

    const updateAch = (data) => {
        updateModal.current.addData({ ...data, timeout: (data.timeout / 1000) || null })
        updateRuleRef.current.show()
    }

    const resetEventPonctuation = (eventId) => {
        del(`${url}${paths.FLUSH_POINTS(eventId)}`, {}, { headers: { authorization: "test" } }).then(() => {
            alert("Event flush finished!")
            getAllEvents()
        })
    }

    const leaderboardRef = useRef(null)

    if (leaderboardRef.current) leaderboardRef.current.closeLeaderboard()

    return <>
        <div>
            <input ref={input} id="eventid" placeholder="Event ID" class="tk-text-inp-large" />
            <button class="tk-btn" onClick={submit}>Search</button>
            {eventId && <button class="tk-btn" onClick={report}>Export Report</button>}
        </div>

        <h1>Events</h1>
        <table class="tk-table">
            <tr class="tk-head">
                <th>Event ID</th>
                <th>Achievements Count</th>
                <th>Total Points</th>
                <th>Actions</th>
            </tr>
            {events ? events.map(event => {
                return <tr>
                    <td>{event.eventId}</td>
                    <td>{event.quantity}</td>
                    <td>{event.points}</td>
                    <td><button class="tk-btn danger" onClick = {() => resetEventPonctuation(event.eventId)}>Reset ALL Points</button></td>
                </tr>
            }) : <tr><td colSpan = "2">"Loading"</td></tr>}
        </table>

        <h1>Achievements</h1>
        <table class="tk-table">
            <tr class="tk-head">
                <th>id</th>
                <th>name</th>
                <th>description</th>
                <th>points</th>
                <th>event ID</th>
                <th>Allows Multiple</th>
                <th>Timeout</th>
                <th>Multiple Limit</th>
                <th>Active</th>
                <th>Hidden</th>
                <th>Delete</th>
                <th>Update</th>
            </tr>
            {achievements && achievements.length > 0 ? achievements.map(row =>
                <tr>
                    <td>{row.id}</td>
                    <td>{row.name}</td>
                    <td>{row.description}</td>
                    <td>{row.value}</td>
                    <td>{row.eventId}</td>
                    <td>{row.allowsMultiple ? "Yes" : "No"}</td>
                    <td>{row.timeout ? row.timeout / 1000 + " Sec" : "no-timeout"}</td>
                    <td>{row.allowsMultiple ? row.limit || "unlimited" : "-"}</td>
                    <td>{row.isActive ? "Yes" : "No"}</td>
                    <td>{row.isHidden ? "Yes" : "No"}</td>
                    <td><button class="tk-btn danger" onClick={() => deleteAch(row.id)}>delete</button></td>
                    <td><button class="tk-btn" onClick={() => updateAch(row)}>update</button></td>
                </tr>) : <tr><td class="tk-empty" colSpan="12">- Empty -</td></tr>
            }
        </table>
        <button class="tk-btn" onClick={() => addRuleRef.current.show()} >Add Rule</button>
        <Modal title="Create New Rule" ref={addRuleRef}><CreateModal submit={formSubmit} /></Modal>
        <Modal title="Update Rule" ref={updateRuleRef}><CreateModal ref={updateModal} submit={updateSubmit} update={true} /></Modal>
        <FloatingButtons elements={[
            {
                bgcolor: "#4689ed",
                height: 200,
                icon: <img src="https://static1.tkevents.io/assets/components/leaderboard.png" style={
                    {
                        width: "100%",
                        height: "auto",
                        filter: "brightness(0) invert(1)"
                    }
                } />,
                name: "Leaderboard",
                component: <Leaderboard entrypoint="http://localhost" userId="testgui" eventId="test" name="gui" />
            }
        ]} />
        <button onClick={() => {
            leaderboardRef.current.openLeaderboard()
        }}>Open Leaderboard</button>

        <Leaderboard
            ref={leaderboardRef}
            userId= {new Date().toString()}
            eventId="5432"
            name={"Guilherme Baule 3"}
            entrypoint="http://localhost"
            poolingSec={3} />
    </>
}

render(<App />, document.getElementById("content"))
